import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-footer-contact',
  templateUrl: './edit-footer-contact.component.html',
  styleUrls: ['./edit-footer-contact.component.scss']
})
export class EditFooterContactComponent implements OnInit, AfterViewInit {
  @Input() footerContactInfo: any;
  contactForm: FormGroup;
  fileImg64: any;
  wrongSize: any;

  constructor(
    private fb: FormBuilder,
    private serviceModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  ngAfterViewInit(): void {
    this.updateForm();
  }

  private createForm(): any {
    this.contactForm = this.fb.group({
      name: ['', Validators.required],
      id: [0, Validators.required],
      img: ['', Validators.required],
      img64: [''],
      img64Upload: [false],
      cellPhone: ['', Validators.required],
    });
  }

  private updateForm(): any {
    this.contactForm.get('name').setValue(this.footerContactInfo.name);
    this.contactForm.get('id').setValue(this.footerContactInfo.id);
    this.contactForm.get('img').setValue(this.footerContactInfo.img);
    this.contactForm.get('cellPhone').setValue(this.footerContactInfo.url);
    this.fileImg64 = this.footerContactInfo.img;
  }

  sendData() {
    this.serviceModal.close(this.contactForm.value);
  }



  getBase64(event): void {
    const reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = () => {
      const image = new Image();
      image.src = String(reader.result);
      image.onload = () => {
        if (image.width <= 35 && image.height <= 35) {
          this.wrongSize = null;
          this.fileImg64 = image.src;
          this.contactForm.get('img').setValue((event.target.files[0]).name);
          this.contactForm.get('img64').setValue(this.fileImg64.split(',')[1]);
          this.contactForm.get('img64Upload').setValue(true);
        } else {
          this.wrongSize = 'Resolución de imagen no permitida (requerida: 35px x 35px)';
          return false;
        }
      };
    };
    reader.onerror = (error) => {
    };
  }
}
